/*
 * @Author: bbqin
 * @Date: 2022-02-17 10:14:59
 * @LastEditTime: 2022-03-18 15:55:08
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TransferTable\util.js
 * (混沌)足够多的方案才能接近真实的结果。
 */

import { microAppUtil } from '@platform/api';

export function getTableWidth(classname) {
    let table = microAppUtil.getDocument().querySelector(`.${classname} .base-table-body-scroll-wrapper`);
    let width = table ? table.getBoundingClientRect().width : undefined;
    return width;
}